import type { Distance, SpatialRectangle } from "@pdfking/math"
import type { ConcretePlotObject } from "./BasePlotObject"
import type { PlotFunction } from "./PlotFunction"

// Specific type for plot_rect
export type PlotRect = {
  enum: PlotFunction.PLOT_RECT
  position: SpatialRectangle<Distance>
} & ConcretePlotObject
